// @ts-strict-ignore
import { Dictionary } from 'typescript-collections';

export class VolatileDataSetHolder {
  public static readonly DATA_SET_LABEL_EDITOR_ASSISTANT: string = 'labelEditorAssistantPopup';
  public static readonly DATA_SET_DRILLINGHOLEWIZARD: string = 'drillingholeWizard';
  public static readonly DATA_SET_DRILLINGHOLEPRESET_KEY: string = 'drillingholepreset';
  public static readonly DATA_SET_CACHED_DRILLINGHOLE_OFFSET_KEY: string = 'cacheddrillingholeoffset';
  public static readonly DATA_SET_PROJECT_PRICING: string = 'projectPricing';
  public static readonly DATA_SET_CUSTOM_ADDRESS_NUMBER_KEY: string = 'customAddressNumber';
  public static readonly DATA_SET_CUSTOM_SALES_ORGANISATION_KEY: string = 'customSalesOrganisation';

  private static _instance: VolatileDataSetHolder = null;

  public static get instance(): VolatileDataSetHolder {
    if (!this._instance) {
      this._instance = new VolatileDataSetHolder();
    }
    return this._instance;
  }

  private availableDataSets: Dictionary<string, Dictionary<string, any>> = null;

  public constructor() {
    if (!this.availableDataSets) {
      this.availableDataSets = new Dictionary<string, Dictionary<string, any>>();
    }
  }

  public getDataSetValue(setName: string, key: string): any {
    if (this.isSetAvailable(setName) && this.availableDataSets.getValue(setName).containsKey(key)) {
      return this.availableDataSets.getValue(setName).getValue(key);
    }
    return null;
  }

  public setDataSetValue(setName: string, key: string, value: any): void {
    if (!this.isSetAvailable(setName)) {
      this.setDataSet(setName, new Dictionary<string, any>());
    }
    this.availableDataSets.getValue(setName).setValue(key, value);
  }

  public setDataSet(setName: string, set: Dictionary<string, any>): void {
    this.availableDataSets.setValue(setName, set);
  }

  /**
   * Returns a set for the given setName
   * creates a new empty Set if setName was not used before
   *
   **/
  public getDataSet(setName: string): Dictionary<string, any> {
    if (!this.isSetAvailable(setName)) {
      this.availableDataSets.setValue(setName, new Dictionary<string, any>());
    }
    return this.availableDataSets.getValue(setName);
  }

  /**
   * Returns a saved set for the given setName or null if the no set with the given setName is found
   *
   **/
  public getExistingDataSet(setName: string): Dictionary<string, any> {
    if (this.availableDataSets.containsKey(setName)) {
      return this.availableDataSets.getValue(setName);
    }
    return null;
  }

  public isSetAvailable(setName: string): boolean {
    if (this.availableDataSets.containsKey(setName)) {
      return true;
    }
    return false;
  }
}
